import $ from 'jquery';

export default class VatNumberValidation {
  #vatInput;
  #companyField;
  #form;
  #submitButton;
  #selectors = {
    vatInput: 'input[name="vat_number"]',
    companyField: 'input[name="company"]'
  };
  #errorMessages = {
    nipValidation: '',
    companyValidation: ''
  };

  constructor() {
    this.#vatInput = $(this.#selectors.vatInput);
    if (!this.#vatInput.length) return;
    
    this.#form = this.#vatInput.closest('form');
    this.#companyField = this.#form.find(this.#selectors.companyField);
    this.#submitButton = this.#form.find('[type="submit"]');
    
    this.#errorMessages = {
      nipValidation: this.#vatInput.data('nipValidationError'),
      companyValidation: this.#vatInput.data('companyValidationError')
    };
  }

  init() {
    if (!this.#vatInput || !this.#form) return;
    this.#bindEvents();
  }

  #bindEvents() {
    this.#form.on('submit', (e) => {
      if (!this.#validateForm()) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    this.#vatInput.on('input', () => this.#enableFormSubmission());
    this.#companyField.on('input', () => this.#enableFormSubmission());
  }

  #enableFormSubmission() {
    this.#clearError();
    this.#submitButton.prop('disabled', false).removeClass('disabled');
    this.#form.data('disabled', false);
  }

  #validateForm() {
    const vatNumber = this.#vatInput.val().trim();
    const companyName = this.#companyField.val().trim();
    const errors = [];

    if (!vatNumber) {
      this.#clearError();
      return true;
    }

    if (!this.#isValidNIP(vatNumber)) {
      errors.push(this.#errorMessages.nipValidation);
    }

    if (!companyName) {
      errors.push(this.#errorMessages.companyValidation);
    }

    if (errors.length > 0) {
      this.#showError(errors);
      return false;
    }

    this.#clearError();
    return true;
  }

  #isValidNIP(nip) {
    nip = nip.replace(/[^0-9]/g, '');
    
    if (nip.length !== 10) return false;

    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    const sum = weights.reduce((acc, weight, index) => {
      return acc + (parseInt(nip[index]) * weight);
    }, 0);

    const checksum = sum % 11;
    return checksum === parseInt(nip[9]);
  }

  #showError(messages) {
    const $wrapper = this.#vatInput.closest('.form-group');
    const $errorWrapper = $wrapper.find('.error-wrapper');
    
    $wrapper.addClass('form-error');
    $errorWrapper
      .removeClass('alert-success')
      .addClass('alert alert-danger mt-1')
      .html(Array.isArray(messages) ? messages.join('<br>') : messages)
      .slideDown();

    $('html, body').animate({
      scrollTop: $wrapper.offset().top - 100
    }, 500);
  }

  #clearError() {
    const $wrapper = this.#vatInput.closest('.form-group');
    const $errorWrapper = $wrapper.find('.error-wrapper');
    
    $wrapper.removeClass('form-error');
    $errorWrapper
      .removeClass('alert alert-danger')
      .empty()
      .hide();
  }
}
